import React from 'react';
import * as TotemActions from '../actions/TotemActions';
import TotemStore from '../stores/TotemStore';

class BrandItemComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        //$('.tooltipped').tooltip({ delay: 10 });
    }

    _handleDeleteBrand() {
        TotemActions.deleteBrand(this.props.brand.id);
    }

    _handleEditItem() {

    }

    render() {
        return (
            <tr>
                <td>
                    <span>{this.props.brand.name}</span>
                </td>
                <td className="items-actions">
                    <i className="fa fa-pencil item-action tooltipped" data-position="top" data-tooltip="Editar" onClick={this._handleEditItem.bind(this)} />
                    <i className="fa fa-trash item-action tooltipped" data-position="top" data-tooltip="Eliminar" onClick={this._handleDeleteBrand.bind(this)} />
                </td>
            </tr>
        );
    }
}

export default BrandItemComponent;


// WEBPACK FOOTER //
// ./src/components/BrandItemComponent.js